import Vue from 'vue'

const state = {
  userId: 0,
  userName: ''
}

const mutations = {
  SET_USER_ID(state, userId) {
    state.userId = userId
  },
  SET_USER_NAME(state, userName) {
    state.userName = userName
  }
}

const actions = {
  setUserId: ({ commit }, userId) => {
    commit('SET_USER_ID', userId)
  },
  setUserName: ({ commit }, name) => {
    commit('SET_USER_NAME', name)
  },
  doLogin: ({ commit, dispatch }, { email, password, router }) => {
    Vue.http
      .post('login', { user: email, pass: password })
      .then(response => response.json())
      .then(data => {
        if (data.id) {
          commit('SET_USER_ID', data.id)
          commit('SET_USER_NAME', data.name)
          localStorage.setItem('userId', data.id)
          localStorage.setItem('userName', data.name)
          router.push('/events')
        }
      })
      .catch(_ => {
        dispatch('setSnackbarColor', 'error')
        dispatch('setSnackbarMessage', 'Login Incorreto')
        dispatch('setSnackbarOpen', true)
      })
  },
  doLogout: ({ commit, dispatch }) => {
    commit('SET_USER_ID', 0)
    commit('SET_USER_NAME', '')
    localStorage.removeItem('userId')
    localStorage.removeItem('userName')
    dispatch('eraseLocalEventData')
    dispatch('eraseLocalProductsData')
  },
  tryAutoLogin: ({ commit }) => {
    const userId = localStorage.getItem('userId')
    if (!userId) {
      return
    }
    commit('SET_USER_ID', userId)
    const userName = localStorage.getItem('userName')
    if (!userName) {
      return
    }
    commit('SET_USER_NAME', userName)
  }
}

const getters = {
  userId(state) {
    return state.userId
  },
  userName(state) {
    return state.userName
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js